import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { viewNews } from "../../states/actions/newsAction";
import BaseUrl from "../../service/API/base_url";
import { FormatDate } from "../Date/Date";

const Blogs = () => {
  // dispatch
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // hooks
  const News = useSelector((state) => state.News);
  // use effect
  useEffect(() => {
    dispatch(viewNews());
  }, []);

  const handleGetDetail = (singleNews) => {
    navigate(`/news-detail/${singleNews.id}`, { state: { singleNews } });
  };

  // console.log("news info : ", News);

  return (
    <main data-aos="fade-up" data-aos-offset="200">
      <section className="container mb-10 py-8">
        <h1 className="border-l-8 pl-2 text-start font-normal font-serif text-xl md:text-4xl mb-0">
          From
          <strong class="text-[#527C88]"> Aderaw </strong>
        </h1>
        <p className="text-start font-normal font-serif text-lg md:text-xl py-6">
          ላደረከው በጎም ሆነ መጥፎ ነገር እጥፍ ሆኖ ይከፈልሃል
        </p>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
          {News?.News?.slice(0, 3).map((data, index) => (
            <div className="p-4 shadow-lg transition-all duration-500 hover:shadow-xl dark:bg-slate-950">
              <div className="overflow-hidden">
                <img
                  src={`${BaseUrl}/${data?.photo}`}
                  alt="No image"
                  className="mx-auto h-[250px] w-full object-cover transition duration-700 hover:skew-x-2 hover:scale-110"
                />
              </div>
              <div className="flex justify-between pt-2 text-slate-600">
                <p>{FormatDate(data?.createdAt)}</p>
                <p className="line-clamp-1">{data?.author} </p>
              </div>
              <div className="space-y-3 py-3">
                <h1 className="line-clamp-1 text-xl font-bold">
                  {data?.title}
                </h1>
                <p className="line-clamp-2">{data?.description}</p>
              </div>
              <div className="flex justify-center items-center pt-2">
                <button
                  class="group relative inline-block text-sm font-medium text-yellow-500 focus:ring-3 focus:outline-hidden"
                  onClick={() => handleGetDetail(data)}
                >
                  <span class="absolute inset-0 translate-x-0.5 translate-y-0.5 bg-yellow-500 transition-transform group-hover:translate-x-0 group-hover:translate-y-0"></span>

                  <span class="relative block border border-current bg-white px-6 py-2">
                    {" "}
                    Read More{" "}
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Blogs;
